// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__339ya","inner":"Footer_inner__2r5AM","nextIcon":"Footer_nextIcon__Wvvfz","innerLeft":"Footer_innerLeft__HF75R"};